var map = {
	"./cs.json": 23872,
	"./de.json": 15089,
	"./en.json": 40517,
	"./es.json": 77486,
	"./fr.json": 21254,
	"./nb.json": 38606,
	"./nl.json": 66872,
	"./pl.json": 50690,
	"./pt-BR.json": 90157,
	"./pt.json": 82602,
	"./sv.json": 67039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48569;